import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveCovenant() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((covenantId, payload) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = covenantId
      ? quarkusApi.put(`/covenant-catalog/${covenantId}`, payload, authHeader)
      : quarkusApi.post('/covenant-catalog', payload, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
